module.exports = __webpack_public_path__ + "static/media/ex12.7f0d9db6.jpg";